import DocumentsApi from '@/api-interface/document'

export default {
  namespaced: true,

  state: {
    list: []
  },

  getters: {
    allFileNames(state) {
      return state.list.map((doc) => doc.documentName)
    }
  },

  mutations: {
    FETCHED_LIST(state, list) {
      state.list = list
    }
  },

  actions: {
    async fetch({ commit, rootState }) {
      const response = await DocumentsApi.list({ companyKey: rootState.company.currentCompanyInfo.companyKey })
      commit('FETCHED_LIST', response)
    }
  }
}
